import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import customPropTypes from 'util/customPropTypes'
import { notImplemented } from 'util/functions'
import { Accordion as SUIAccordion } from 'util/ui'
import SidebarLabel from 'components/App/DesktopView/Layout/Sidebar/SidebarLabel'

const Accordion = styled(SUIAccordion)`
  & + & {
    margin-top: ${props => props.theme.spacing['10']};
  }
`

const Title = styled(SUIAccordion.Title)`
  &&&&&& {
    // win over SUI
    margin-bottom: 0;
    padding: 0;
    text-transform: none;
  }
`

const Content = styled(SUIAccordion.Content)`
  &&&& {
    // win over SUI
    padding: 0 !important;
    .accordion {
      margin-top: 0;
    }
  }
`

export default class SidebarTopLevelAccordion extends React.PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    children: customPropTypes.children.isRequired,
    className: PropTypes.string,
    initiallyActive: PropTypes.bool,
    title: customPropTypes.child,
    onToggle: PropTypes.func,
  }

  static defaultProps = {
    active: null,
    initiallyActive: false,
    className: undefined,
    title: undefined,
    onToggle: notImplemented('onToggle'),
  }

  constructor(props) {
    super(props)
    this.state = {
      active: props.initiallyActive,
    }
  }

  toggleActive = event => {
    const { onToggle } = this.props
    const newActive = !this.state.active
    this.setState({ active: newActive })
    if (onToggle) onToggle(event, newActive)
  }

  get isActive() {
    if (this.props.active === true || this.props.active === false)
      return this.props.active
    return this.state.active
  }

  render() {
    const { className, children, title, allowMultiple = false } = this.props
    return (
      <div style={{ overflowY: 'auto' }}>
        <Accordion className={className} inverted exclusive={!allowMultiple}>
          <Title
            className="clickable"
            active={this.isActive}
            onClick={this.toggleActive}
          >
            <SidebarLabel>{title}</SidebarLabel>
          </Title>
          <Content active={this.isActive}>{children}</Content>
        </Accordion>
      </div>
    )
  }
}
